import { Component } from '@angular/core';
import { CommonService } from '@core/services/common-service/common.service';
import { GlobalConstants } from '@environments/global-Variables';
import { TableRecord } from '@shared/components/ui-components/table/table.component';
import { Column } from '@shared/models/column-interface';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';

@Component({
  selector: 'weaccess-view-history-modal',
  templateUrl: './view-history-modal.component.html',
  styleUrls: ['./view-history-modal.component.scss']
})
export class ViewHistoryModalComponent {

  globalConstants = GlobalConstants;

  bsSystemAccessModalRef!: BsModalRef;
  systemDataSubscription!: Subscription;
  accessData: any;
  historyTableData!: Array<TableRecord>;
  constructor(
    private bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private commonService: CommonService) {
    this.accessData = this.modalService.config.initialState
  }

  ngOnInit() {
    this.getSystemHistoryData();
  }

  /** Getting person history data API implementation */
  getSystemHistoryData() {
    let personReqParam: any;
    if (this.accessData?.data?.type === 'mySelf') {
      personReqParam = {
        personId: 0
      }
    } else {
      personReqParam = {
        personId: this.accessData?.data?.personID
      }
    }

    this.systemDataSubscription = this.commonService.getSystemAccessCompleteHistory(personReqParam).subscribe((historyData: any) => {
      this.historyTableData = historyData;
    });
  }

  /**Close modal functionality */
  onClose() {
    this.bsModalRef.hide();
  }

  /**Close modal functionality */
  closeModal(): void {
    this.onClose();
  }

  /** MySelf Table column configuration  */
  historyTableColumns: Array<Column> = [
    {
      columnDef: 'serialNo',
      header: 'Sr No',
      cell: (element: Record<string, any>) => `${element['serialNo']}`
    },
    {
      columnDef: 'appName',
      header: 'System Access',
      cell: (element: Record<string, any>) => `${element['appName']}`
    },
    {
      columnDef: 'currentStatus',
      header: 'Current Status',
      cell: (element: Record<string, any>) => `${element['currentStatus']}`,
      // isButton: true
    },
    {
      columnDef: 'requestType',
      header: 'Request Type',
      cell: (element: Record<string, any>) => `${element['requestType']}`
    },
    {
      columnDef: 'createdDate',
      header: 'Submission Date',
      cell: (element: Record<string, any>) => `${element['createdDate']}`
    },
    {
      columnDef: 'justification',
      header: 'Justification',
      cell: (element: Record<string, any>) => `${element['justification']}`
    },
  ];

}
